import { get } from "./api";
import type { ClientsOutput } from "./types";

export type ClientOption = ClientsOutput["clients"][number];

/**
 * Every client including former ones (with status). For display and for a row's
 * own current client; the key keeps the ["clients"] prefix so existing invalidations hit.
 */
export const allClientsQuery = {
  queryKey: ["clients", "all"],
  queryFn: () => get<ClientsOutput>("/api/clients?includeFormer=1"),
};

/** Choices for picking a client: former ones are hidden unless they are the current value. */
export function pickableClients(clients: ClientOption[], keep: (number | null | undefined)[] = []): ClientOption[] {
  return clients.filter((c) => c.status !== "former" || keep.includes(c.id));
}

export function clientLabel(c: ClientOption): string {
  return c.status === "former" ? `${c.name} · ehemalig` : c.name;
}
